export const PublicPages = [
  'login',
  'forgotpassword',
  'googlelogin',
  'ezlogin',
  'resetpassword',
  'oauthshareconnect',
  'oauthsharesuccess',
  'oauthshareerror',
];

export const WelcomePathName = 'welcome';
